import React, { FC, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { Loader } from '$shared/components';
import { authActions } from '$store/auth';

export const GoogleAuth: FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const hashParams = new URLSearchParams(
      '?' + String(window.location.hash || '').substring(1),
    );

    if (hashParams.get('id_token')) {
      dispatch(authActions.googleAuth(hashParams.get('id_token')!));
    } else {
      location.href = '/';
    }
  }, []);

  return (
    <>
      <Loader isWrapped />
    </>
  );
};
